import { render, staticRenderFns } from "./MenuLevel.vue?vue&type=template&id=11380f9e&scoped=true"
import script from "./MenuLevel.vue?vue&type=script&lang=js"
export * from "./MenuLevel.vue?vue&type=script&lang=js"
import style0 from "./MenuLevel.vue?vue&type=style&index=0&id=11380f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11380f9e",
  null
  
)

export default component.exports